var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPage,{staticClass:"mt-7",attrs:{"title":""}},[_c('div',{staticClass:"step-page-card"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }